import apiService from '../../../services/api'

/**
 * Stars Withdraw API
 * Вывод кристаллов покупкой Telegram Stars на ник получателя
 *
 * - GET /api/stars-withdraw/ — котировка, лимиты, активная заявка и история
 * - POST /api/stars-withdraw/ — создать заявку { stars, username, crystals }
 *
 * parseForbidden: 403 (disabled / deposit required / withdraw banned) разбирается вызывающим кодом
 */

/**
 * Перевод звёзд в кристаллы — целыми числами с округлением вверх, ровно как на бэкенде.
 * BigInt — чтобы не терять точность Number на больших значениях.
 * @param {number} stars — количество звёзд
 * @param {Object} quote — { price_micro, crystals_per_dollar, commission_percent }
 * @returns {number|null} кристаллы или null, если котировки нет
 */
export const starsToCrystals = (stars, quote) => {
  if (!quote?.price_micro || !quote?.crystals_per_dollar || !Number.isInteger(stars) || stars <= 0) return null
  const num = BigInt(stars) * BigInt(quote.price_micro) * BigInt(quote.crystals_per_dollar) * 100n
  const den = 1000000n * BigInt(100 - quote.commission_percent)
  return Number((num + den - 1n) / den)
}

/**
 * Нормализация ника: пробелы по краям, префикс t.me/ и ведущий @
 * @param {string} value — введённый ник
 * @returns {string}
 */
export const normalizeUsername = (value) => (value || '')
  .trim()
  .replace(/^(https?:\/\/)?t\.me\//i, '')
  .replace(/^@/, '')

export const isValidUsername = (username) => /^[A-Za-z0-9_]{4,32}$/.test(username)

const fetchStarsWithdrawData = () => apiService.makeRequest('/api/stars-withdraw/', { parseForbidden: true })

const createStarsWithdraw = ({ stars, username, crystals }) => apiService.makeRequest('/api/stars-withdraw/', {
  method: 'POST',
  parseForbidden: true,
  body: JSON.stringify({ stars, username, crystals }),
})

export default {
  fetchStarsWithdrawData,
  createStarsWithdraw,
}
